import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { SetBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/BookOfMindHelpers";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { HandleBookOfMindTurnPageRequest } from "../../Tools/TurnPageLink/Helpers/HandleBookOfMindTurnPageRequest";
import { bookOfMindSpeech } from "../BookOfMindSpeech";
import { WaitAsync } from "./WaitAsync";

export function SpeakItems(items: string[], startAtIndex: number) {
    let isCancelled = false;

    async function SpeakItemsAsync() {
        for (let index = 0; index < items.length; index++) {
            if (isCancelled) {
                return;
            }

            if (!(await WaitForSpeechResumeAsync(() => isCancelled))) {
                return;
            }

            if (index < startAtIndex) {
                continue;
            }

            ScrollToItem(index);
            SetBookOfMindState({
                spokenQuoteIndex: index,
                spokenWordStartIndex: undefined,
                spokenWordEndIndex: undefined,
            });
            await bookOfMindSpeech.SpeakItemInChainAsync(
                items[index],
                index,
                () => {
                    const nextItem = items[index + 1];
                    if (nextItem) {
                        bookOfMindSpeech.PrefetchNextGoogleSpeech(
                            nextItem,
                            index + 1
                        );
                    }
                }
            );
            if (isCancelled) {
                return;
            }

            await WaitAsync(1250);
        }

        if (isCancelled) {
            return;
        }

        if (!(await WaitForSpeechResumeAsync(() => isCancelled))) {
            return;
        }

        await bookOfMindSpeech.SpeakSingleTextAsync(`page complete.`);
        if (isCancelled) {
            return;
        }

        bookOfMindSpeech.StopSpeech();
        HandleBookOfMindTurnPageRequest();
        bookOfMindSpeech.ScheduleStartAfterPageTurn(2000);
    }

    SpeakItemsAsync();

    return () => {
        isCancelled = true;
    };
}

async function WaitForSpeechResumeAsync(
    isCancelled: () => boolean
): Promise<boolean> {
    while (!isCancelled()) {
        const state = ReadState<IBookOfMindState>(ESharedFunction.BookOfMind);

        if (state?.isSpeechActive) {
            return true;
        }

        await WaitAsync(100);
    }

    return false;
}

function ScrollToItem(index: number) {
    try {
        const scrollContainer = document.getElementById(`childContainer`);
        const targetElement = document.getElementById(
            `scrollTarget_bomq_${index}`
        );

        if (!scrollContainer || !targetElement) {
            return;
        }

        const containerRect = scrollContainer.getBoundingClientRect();
        const targetRect = targetElement.getBoundingClientRect();
        const topPadding = 12;
        const bottomPadding = 12;
        const visibleTop = containerRect.top + topPadding;
        const visibleBottom = containerRect.bottom - bottomPadding;

        let scrollDelta = 0;

        if (targetRect.top < visibleTop) {
            scrollDelta = targetRect.top - visibleTop;
        } else if (targetRect.bottom > visibleBottom) {
            scrollDelta = targetRect.bottom - visibleBottom;
        }

        if (scrollDelta !== 0) {
            scrollContainer.scrollTo({
                top: scrollContainer.scrollTop + scrollDelta,
                behavior: `smooth`,
            });
        }
    } catch {
        console.warn(`Could not scroll to item with index ${index}`);
    }
}
